import messages from "i18n/messages";
import { Background } from "components/index";
import first from "lodash/first";
import Head from "next/head";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { FormattedMessage, FormattedDate } from "react-intl";
import { defaultDateFormat } from "../lib/misc";

const EventSaleCountdown = ({ date, event }) => {
  const [dur, setDur] = useState(null);

  const countdown = () => {
    var eventTime = moment(date.tt_sale_starts_at);
    var currentTime = moment();
    var diffTime = eventTime - currentTime;
    if (diffTime < 1000) {
      location.reload();
    }
    setDur(moment.duration(diffTime));
    setTimeout(countdown, 1000);
  };

  useEffect(() => {
    countdown();
  }, []);

  const eventImgSrc =
    event.images && first(event.images) ? first(event.images).full : null;

  return (
    <div>
      <Head>
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      <div className="tt-waiting-room-wrap tt-countdown-wrap">
        <div className="tt-waiting-room-box">
          <Background noBlur imgSrc={eventImgSrc} />
          <div className="pb-4">
            <div className="title">{date.title}</div>
            <div className="subtitle text-center">{date.subtitle}</div>
            <div className="subtitle text-center font-weight-bold">
              <FormattedDate value={date.starts_at} {...defaultDateFormat} />
            </div>
            <div className="text-center mt-4">
              <div className="text">
                <FormattedMessage {...messages.saleStartsIn} />
              </div>
              <div className="wr-pos-wrap">
                <div className="wr-pos">
                  {dur ? (
                    <div className="wr-pos-pos">
                      {dur.hours().toString().padStart(2, "0")}:
                      {dur.minutes().toString().padStart(2, "0")}:
                      {dur.seconds().toString().padStart(2, "0")}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventSaleCountdown;
